import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  toolboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& .MuiButton-root': {
      marginLeft: '10px'
    }
  },
  noUnits: {
    padding: '24px 72px',
    backgroundColor: palette.shades[200]
  },
  generalExpander: {
    display: 'inline-block',
    backgroundColor: palette.shades[100],
    width: '24px !important',
    height: '24px !important',
    padding: '0',
    transition: "all ".concat(palette.transitions.short),
    '&:hover': {
      backgroundColor: palette.shades[100],
      cursor: 'pointer'
    }
  },
  expanded: {
    transform: 'rotate(90deg)'
  },
  formerTableWrapper: {
    boxShadow: palette.shadows.light,
    overflowX: 'auto'
  },
  formerTableContent: {
    minWidth: '1280px'
  },
  formerTenantsTable: {
    boxShadow: 'none'
  },
  formerTable: {
    whiteSpace: 'break-spaces',
    '& .MuiTableBody-root .MuiTableRow-root': {
      backgroundColor: palette.shades[200]
    },
    '& .MuiTableCell-root:first-child': {
      paddingLeft: '18px'
    },
    '& .MuiTableCell-root:last-child': {
      paddingRight: '18px'
    }
  },
  xsCell: {
    width: '60px'
  },
  smCell: {
    width: '80px'
  },
  mdCell: {
    width: '100px'
  },
  lgCell: {
    width: '120px'
  },
  residentCell: {
    width: '200px'
  },
  accordionWrapper: {
    boxShadow: 'none',
    borderRadius: '0',
    '& .MuiTableContainer-root ': {
      boxShadow: 'none'
    },
    '& .MuiAccordionSummary-root': {
      padding: '16px 0',
      flexDirection: 'row-reverse'
    },
    '& .MuiAccordionSummary-content': {
      paddingLeft: '4px'
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      padding: '0 18px',
      '& path': {
        fill: palette.shades[700]
      }
    },
    '& + &': {
      marginTop: '0',
      '& .MuiAccordionSummary-root': {
        borderTop: "1px solid ".concat(palette.shades[300])
      }
    },
    '&.Mui-expanded': {
      margin: '0',
      '& .MuiAccordionSummary-root': {
        borderBottom: "1px solid ".concat(palette.shades[300])
      }
    },
    '& .MuiTableBody-root tr:last-of-type': {
      '& .MuiTableCell-root:before': {
        height: ' 50%'
      }
    }
  }
});
export default useStyles;